import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import Url from '@core/scripts/helper/url';
import WishlistMessages from "../components/messages";

export default function removeFromWishlist(styleId, itemId) {
    let url;
    if (itemId) {
        url = Url.toAbsolute(`list/wishlist/variant/?digistyleId=${styleId}&itemId=${itemId}`);
    } else {
        url = Url.toAbsolute(`list/wishlist/?digistyleId=${styleId}`);
    }

    return fetchWithCSRF(url, {
        method: "DELETE"
    }).then((response) => {
        if (!response.ok) {
            throw Error(`Could not delete wishlist item. ${styleId}`);
        }
        response.text().then((currentCount) => {
        MessageBroker.publish(WishlistMessages.WISHLIST.ITEM_DELETED, {
                digistyleId: parseInt(styleId),
                itemId: itemId !== undefined ? parseInt(itemId) : null,
                currentItemsInWishlist: parseInt(currentCount)
            });
        });
    }).catch((error) => {
        Logger.error('Could not remove product from wishlist!', error);
    });
}